import React from 'react';

export const TrendingContentContext = React.createContext<{
  followedGroupIds: number[];
}>({
  followedGroupIds: [],
});
